/**
 * セッションの複数選択状態を共有する Context。
 * SlackMentionsSection が Provider となり、NodeRow / MentionRow (embedded session) が
 * チェックボックスを表示するために参照する。
 * Provider がない画面 (TaigaSheetDetailPage 等) では null になり、チェックボックスは出ない。
 *
 * 選択キーは cc-server のセッション ID (= Claude Code の session id)。
 * コピーするコマンドがこの id で `claude --resume` するため、cc_session_id 未登録の
 * セッションは選択できない (チェックボックスは disabled)。
 * name (ノード名) はセッション名 (`claude --name`)、worktreePath は resume 時の
 * 起動ディレクトリとしてコマンドに埋め込まれる。
 */
import { createContext, useContext } from "react"

export type SelectedCcSession = {
	ccSessionId: string
	name: string
	worktreePath: string | null
}

export type SessionSelection = {
	selectedCcSessions: ReadonlyMap<string, SelectedCcSession>
	toggleCcSession: (session: SelectedCcSession) => void
}

export const SessionSelectionContext = createContext<SessionSelection | null>(
	null
)

export const useSessionSelection = () => useContext(SessionSelectionContext)
